// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 我的页面优化 */
.my-page { min-height:100vh; background:var(--color-bg); }
.login-intro { text-align:center; padding:6px 4px 4px; }
.intro-title { font-size:1.35rem; font-weight:700; color:var(--color-text); margin:0 0 10px; letter-spacing:.5px; }
.intro-text { color:var(--color-text-sec); margin:0 0 22px; font-size:.85rem; }

/* 登录按钮与表单 */
.login-form { padding: 20px 0; }
.login-form .form-group { display:flex; flex-direction:column; margin:0 0 18px; }
.login-form .form-group label { color: var(--color-text); font-weight: 600; margin-bottom: 8px; font-size: 0.9rem; }
.login-form input {
  padding: 16px 18px;
  font-size: 16px; /* 防止iOS缩放 */
  border: 1px solid var(--color-border-strong);
  background: var(--color-surface);
  border-radius: 16px;
  transition: var(--transition-fast);
  min-height: 52px; /* 确保触摸目标 */
  width: 100%;
}

.login-form input:focus {
  border-color: var(--color-primary);
  box-shadow: var(--focus-ring);
  outline: none;
  background: var(--color-surface);
}

/* 输入类型特定优化 */
.login-form input[type="tel"] {
  font-family: monospace;
  letter-spacing: 1px;
}

.login-form input[type="text"] {
  text-transform: none;
}

.code-row { display:flex; gap:12px; align-items:flex-end; }
.code-input { flex:1 1; }
.code-btn {
  height: 52px;
  min-height: 52px;
  min-width: 80px;
  padding: 0 20px;
  border: 1px solid var(--color-primary);
  border-radius: 16px;
  background: var(--color-surface);
  color: var(--color-primary);
  cursor: pointer;
  font-weight: 600;
  letter-spacing: .4px;
  transition: var(--transition-fast);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.code-btn:hover:not(:disabled) { background:var(--color-primary); color:#fff; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3); }
.code-btn:disabled { opacity:.6; cursor:not-allowed; }
.btn.submit { width:100%; margin-top:8px; padding:16px 18px; border-radius:18px; font-size: 1rem; font-weight: 600; }

/* 用户信息卡 */
.user-info-card { border-radius:28px; margin:20px 0 24px; padding:30px 26px; position:relative; overflow:hidden; }
.user-info-card::before { content:""; position:absolute; inset:0; background:radial-gradient(circle at 95% 15%,rgba(99,102,241,.2),rgba(255,255,255,0)); pointer-events:none; }
.user-avatar { font-size:52px; margin-right:22px; width:68px; height:68px; display:flex; align-items:center; justify-content:center; background:linear-gradient(145deg,#f2f4f8,#ffffff); color:var(--color-primary); border-radius:50%; box-shadow:inset 0 1px 0 rgba(255,255,255,.6),0 4px 10px -4px rgba(0,0,0,.2); }
.user-details h2 { margin:0 0 6px; font-size:1.2rem; font-weight:700; letter-spacing:.3px; color:var(--color-text); }
.user-details p { margin:4px 0; color:var(--color-text-sec); font-size:.8rem; }
.edit-btn { padding:10px 18px; border-radius:14px; font-size:.8rem; font-weight:600; }

/* 菜单 */
.menu-section { margin:24px 0 10px; }
.menu-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; letter-spacing:.4px; font-weight:700; }
.menu-list { border-radius:26px; overflow:hidden; }
.menu-item { display:flex; justify-content:space-between; align-items:center; padding:18px 22px; border-bottom:1px solid var(--color-border); cursor:pointer; position:relative; transition:var(--transition-base); }
.menu-item:last-child { border-bottom:none; }
.menu-item::after { content:""; position:absolute; inset:0; background:linear-gradient(120deg,rgba(99,102,241,.08),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); }
.menu-item:hover { transform:translateY(-2px); box-shadow:0 4px 14px -6px rgba(0,0,0,.18); }
.menu-item:hover::after { opacity:1; }
.arrow { color:var(--color-muted); font-size:1rem; }

/* 订单列表 */
.orders-section { margin:30px 0 10px; }
.orders-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; font-weight:700; }
.orders-list { border-radius:26px; padding:10px 4px 4px; }
.order-item { display:flex; justify-content:space-between; align-items:center; padding:16px 18px 14px; border-bottom:1px solid var(--color-border); }
.order-item:last-child { border-bottom:none; }
.order-info h4 { margin:0 0 6px; font-size:.95rem; font-weight:600; letter-spacing:.4px; color:var(--color-text); }
.order-info p { margin:2px 0; font-size:.7rem; color:var(--color-text-sec); letter-spacing:.3px; }
.order-price { color:var(--color-danger)!important; font-weight:700; letter-spacing:.4px; }
.order-status { padding:6px 12px; border-radius:20px; font-size:.6rem; letter-spacing:1px; font-weight:700; text-transform:uppercase; box-shadow:0 2px 4px -2px rgba(0,0,0,.12); min-height:24px; display:flex; align-items:center; }
.status-pending { background:var(--color-warning-bg); color:#856404; }

/* 移动端响应式优化 */
@media (max-width: 640px) {
  .user-info-card {
    flex-direction: column;
    text-align: center;
    padding: 24px 20px;
  }

  .user-avatar { margin: 0 0 20px; }

  .edit-btn {
    margin-top: 12px;
    min-height: 44px;
    padding: 12px 20px;
  }

  .menu-item {
    padding: 18px 20px;
    min-height: 56px;
  }

  .order-item {
    padding: 16px 18px 14px;
  }

  /* 表单优化 */
  .login-form input {
    min-height: 52px;
    padding: 16px 18px;
    font-size: 16px;
  }

  .code-btn {
    height: 52px;
    min-width: 90px;
    font-size: 0.85rem;
  }

  .btn.submit {
    min-height: 52px;
    padding: 16px 20px;
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .user-info-card {
    padding: 20px 16px;
    margin: 16px 0 20px;
  }

  .menu-item {
    padding: 16px 18px;
    min-height: 52px;
  }

  .order-item {
    padding: 14px 16px 12px;
  }

  /* 表单移动端优化 */
  .login-form {
    padding: 16px 0;
  }

  .login-form .form-group {
    margin-bottom: 16px;
  }

  .login-form input {
    min-height: 48px;
    padding: 14px 16px;
    border-radius: 14px;
  }

  .code-row {
    gap: 10px;
  }

  .code-btn {
    height: 48px;
    min-width: 80px;
    font-size: 0.8rem;
    padding: 0 16px;
  }

  .btn.submit {
    min-height: 48px;
    padding: 14px 18px;
    font-size: 1rem;
    border-radius: 16px;
  }
}

@media (max-width: 360px) {
  .login-form input {
    min-height: 44px;
    padding: 12px 14px;
  }

  .code-btn {
    height: 44px;
    min-width: 70px;
    font-size: 0.75rem;
    padding: 0 12px;
  }

  .btn.submit {
    min-height: 44px;
    padding: 12px 16px;
  }
}

/* 触摸设备表单优化 */
@media (pointer: coarse) {
  .login-form input {
    min-height: 56px;
    padding: 18px 20px;
  }

  .code-btn {
    height: 56px;
    min-width: 100px;
    padding: 0 24px;
  }

  .btn.submit {
    min-height: 56px;
    padding: 18px 24px;
  }

  .menu-item {
    min-height: 60px;
    padding: 20px 22px;
  }
}

/* 验证码弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background: var(--color-surface);
  border-radius: 20px;
  width: 90%;
  max-width: 400px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--color-border);
}

.modal-header h3 {
  margin: 0;
  color: var(--color-text);
  font-size: 1.2rem;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--color-text-sec);
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: var(--transition-fast);
}

.modal-close:hover {
  background: var(--color-surface-alt);
  color: var(--color-text);
}

.modal-body {
  padding: 24px;
  text-align: center;
}

.code-tip {
  margin: 0 0 16px;
  color: var(--color-text-sec);
  font-size: 0.9rem;
}

.code-display {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-primary);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(99, 102, 241, 0.05));
  border: 2px solid rgba(99, 102, 241, 0.2);
  border-radius: 16px;
  padding: 20px;
  margin: 16px 0;
  letter-spacing: 4px;
  font-family: 'Courier New', monospace;
}

.code-note {
  margin: 16px 0 0;
  color: var(--color-text-sec);
  font-size: 0.8rem;
}

.modal-footer {
  padding: 16px 24px 24px;
}

.btn-primary {
  width: 100%;
  padding: 12px;
  background: var(--color-primary);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}

.btn-primary:hover {
  background: var(--color-primary-accent);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ==========================================================
   用户协议样式
   ========================================================== */

/* 用户协议链接 */
.user-agreement-link {
  text-align: center;
  padding: 24px 20px 32px;
  margin-top: 20px;
}

.agreement-link-btn {
  background: none;
  border: none;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
  font-family: inherit;
  padding: 8px 12px;
  border-radius: 8px;
  transition: var(--transition-fast);
  min-height: 44px;
  min-width: 80px;
}

.agreement-link-btn:hover {
  color: var(--color-primary-accent);
  text-decoration: none;
  background: var(--color-primary-light);
}

/* 用户协议模态框 */
.user-agreement-modal {
  max-width: 900px;
  max-height: 90vh;
}

.user-agreement-content {
  line-height: 1.6;
  color: var(--color-text);
  font-size: 0.9rem;
  text-align: left;
}

.agreement-section-title {
  font-weight: 600;
  color: var(--color-primary);
  margin: 20px 0 12px;
  font-size: 1rem;
  border-left: 4px solid var(--color-primary);
  padding-left: 12px;
}

.agreement-section-title:first-child {
  margin-top: 0;
}

.agreement-subsection-title {
  font-weight: 500;
  color: var(--color-text);
  margin: 12px 0 8px;
  font-size: 0.9rem;
  padding-left: 16px;
}

.agreement-section-content {
  margin-bottom: 16px;
  word-wrap: break-word;
  line-height: 1.7;
}

/* 移动端用户协议样式优化 */
@media (max-width: 480px) {
  .user-agreement-link {
    padding: 20px 16px 28px;
    margin-top: 16px;
  }

  .agreement-link-btn {
    font-size: 0.85rem;
    padding: 6px 10px;
    min-height: 40px;
    min-width: 70px;
  }

  .user-agreement-modal {
    max-height: 85vh;
    border-radius: 16px;
  }

  .user-agreement-content {
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .agreement-section-title {
    font-size: 0.95rem;
    margin: 16px 0 10px;
    padding-left: 10px;
    border-left-width: 3px;
  }

  .agreement-subsection-title {
    font-size: 0.85rem;
    margin: 10px 0 6px;
    padding-left: 14px;
  }

  .agreement-section-content {
    margin-bottom: 14px;
    line-height: 1.6;
  }
}

@media (max-width: 360px) {
  .user-agreement-link {
    padding: 18px 14px 24px;
  }

  .agreement-link-btn {
    font-size: 0.8rem;
    padding: 5px 8px;
    min-height: 36px;
    min-width: 60px;
  }

  .user-agreement-content {
    font-size: 0.8rem;
  }

  .agreement-section-title {
    font-size: 0.9rem;
    margin: 14px 0 8px;
    padding-left: 8px;
  }

  .agreement-subsection-title {
    font-size: 0.8rem;
    margin: 8px 0 4px;
    padding-left: 12px;
  }

  .agreement-section-content {
    margin-bottom: 12px;
  }
}

/* 新增功能样式 */

/* 关于我们模态框 */
.about-content {
  text-align: center;
  padding: 20px 0;
}

.about-content h4 {
  color: var(--color-primary);
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.about-content p {
  margin: 12px 0;
  color: var(--color-text);
  font-size: 1rem;
  line-height: 1.6;
}

/* 消息通知模态框 */
.notification-modal .modal-content {
  max-width: 500px;
  max-height: 70vh;
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-item {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: var(--transition-base);
}

.notification-item:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.notification-header h4 {
  margin: 0;
  color: var(--color-text);
  font-size: 1rem;
  font-weight: 600;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.status-badge.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-badge.status-completed {
  background: #d1edff;
  color: #0c5460;
}

.status-badge.status-review {
  background: #f8d7da;
  color: #721c24;
}

.notification-message {
  color: var(--color-text-sec);
  margin: 8px 0;
  line-height: 1.5;
}

.notification-time {
  color: var(--color-text-muted);
  font-size: 0.8rem;
  margin: 0;
}

/* 收藏夹模态框 */
.favorites-modal .modal-content {
  max-width: 600px;
  max-height: 70vh;
}

.favorites-list {
  max-height: 400px;
  overflow-y: auto;
}

.empty-favorites {
  text-align: center;
  padding: 40px 20px;
  color: var(--color-text-sec);
}

.empty-favorites p {
  margin: 8px 0;
}

.empty-tip {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.favorite-item {
  display: flex;
  align-items: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  gap: 12px;
  transition: var(--transition-base);
}

.favorite-item:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.favorite-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
}

.favorite-info {
  flex: 1 1;
}

.favorite-info h4 {
  margin: 0 0 4px 0;
  color: var(--color-text);
  font-size: 1rem;
  font-weight: 600;
}

.favorite-description {
  color: var(--color-text-sec);
  font-size: 0.85rem;
  margin: 4px 0 8px 0;
  line-height: 1.4;
}

.favorite-details {
  display: flex;
  gap: 12px;
  align-items: center;
}

.favorite-price {
  color: var(--color-primary);
  font-weight: 600;
  font-size: 1rem;
}

.favorite-duration {
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

.favorite-actions {
  flex-shrink: 0;
}

.unfavorite-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: var(--transition-base);
}

.unfavorite-btn:hover {
  background: var(--color-surface-alt);
  transform: scale(1.1);
}



/* 测试账号提示样式 */
.test-account-tip {
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  padding: 12px;
  margin: 16px 0;
  font-size: 0.85rem;
  color: #0369a1;
}

.test-account-tip p {
  margin: 2px 0;
}

/* 订单操作按钮样式 */
.order-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: var(--transition-base);
  min-width: 70px;
}

.confirm-btn {
  background: #10b981;
  color: white;
}

.confirm-btn:hover {
  background: #059669;
}

.review-btn {
  background: var(--color-primary);
  color: white;
}

.review-btn:hover {
  background: #4f46e5;
}

/* 订单状态样式 */
.status-served {
  background: #fef3c7;
  color: #92400e;
}

.status-review {
  background: #fce7f3;
  color: #be185d;
}

/* 空状态样式 */
.empty-orders, .empty-reviews, .empty-appointments {
  text-align: center;
  padding: 40px 20px;
  color: var(--color-text-sec);
}

.empty-orders p, .empty-reviews p, .empty-appointments p {
  margin: 8px 0;
}

/* 评价列表模态框 */
.reviews-modal .modal-content {
  max-width: 600px;
  max-height: 70vh;
}

.reviews-list {
  max-height: 400px;
  overflow-y: auto;
}

.review-item {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.review-header h4 {
  margin: 0;
  color: var(--color-text);
  font-size: 1.1rem;
}

.review-time {
  color: var(--color-text-muted);
  font-size: 0.85rem;
}

.review-ratings {
  margin-bottom: 12px;
}

.rating-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.rating-label {
  min-width: 80px;
  color: var(--color-text-sec);
  font-size: 0.9rem;
}

.stars {
  display: flex;
  gap: 2px;
}

.star {
  color: #e5e7eb;
  font-size: 1rem;
}

.star.filled {
  color: #fbbf24;
}

.review-comment {
  background: var(--color-surface-alt);
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid var(--color-primary);
}

.review-comment p {
  margin: 0;
  color: var(--color-text);
  line-height: 1.5;
}

/* 预约列表模态框 */
.appointments-modal .modal-content {
  max-width: 600px;
  max-height: 70vh;
}

.appointments-list {
  max-height: 400px;
  overflow-y: auto;
}

.appointment-item {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.appointment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.appointment-header h4 {
  margin: 0;
  color: var(--color-text);
  font-size: 1.1rem;
}

.appointment-status {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.appointment-status.status-pending {
  background: #fff3cd;
  color: #856404;
}

.appointment-status.status-progress {
  background: #d1ecf1;
  color: #0c5460;
}

.appointment-details p {
  margin: 6px 0;
  color: var(--color-text-sec);
  font-size: 0.9rem;
}

/* 评价表单模态框 */
.review-form-modal .modal-content {
  max-width: 500px;
}

.service-info {
  background: var(--color-surface-alt);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.service-info h4 {
  margin: 0 0 8px 0;
  color: var(--color-text);
}

.service-info p {
  margin: 0;
  color: var(--color-text-sec);
  font-size: 0.9rem;
}

.rating-section {
  margin-bottom: 20px;
}

.rating-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.rating-row .rating-label {
  min-width: 80px;
  color: var(--color-text);
  font-weight: 500;
}

.star-selector {
  display: flex;
  gap: 4px;
}

.star-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #e5e7eb;
  cursor: pointer;
  transition: var(--transition-fast);
  padding: 2px;
}

.star-btn:hover {
  color: #fbbf24;
  transform: scale(1.1);
}

.star-btn.active {
  color: #fbbf24;
}

.comment-section {
  margin-bottom: 20px;
}

.comment-section label {
  display: block;
  margin-bottom: 8px;
  color: var(--color-text);
  font-weight: 500;
}

.comment-section textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.5;
  resize: vertical;
  min-height: 100px;
}

.comment-section textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: var(--focus-ring);
}

.btn-secondary {
  background: var(--color-surface-alt);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

.btn-secondary:hover {
  background: var(--color-border);
}

/* 收藏夹点击效果 */
.favorite-item.clickable {
  cursor: pointer;
  transition: var(--transition-base);
}

.favorite-item.clickable:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* 评价项优化样式 */
.rating-score {
  margin-left: 8px;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  font-weight: 500;
}

.expand-btn {
  background: none;
  border: none;
  color: var(--color-primary);
  cursor: pointer;
  font-size: 0.85rem;
  margin-top: 8px;
  padding: 4px 0;
  transition: var(--transition-fast);
}

.expand-btn:hover {
  color: #4f46e5;
  text-decoration: underline;
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  /* 评价模态框移动端优化 */
  .reviews-modal .modal-content {
    width: 95%;
    max-height: 85vh;
    margin: 7.5vh auto;
  }

  .review-item {
    padding: 12px;
    margin-bottom: 12px;
  }

  .review-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .review-header h4 {
    font-size: 1rem;
  }

  .review-time {
    font-size: 0.8rem;
  }

  /* 星级显示移动端优化 */
  .rating-item {
    margin-bottom: 6px;
  }

  .rating-label {
    min-width: 70px;
    font-size: 0.85rem;
  }

  .stars {
    gap: 1px;
  }

  .star {
    font-size: 0.9rem;
  }

  .rating-score {
    font-size: 0.75rem;
    margin-left: 4px;
  }

  /* 评价内容移动端优化 */
  .review-comment {
    padding: 10px;
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .expand-btn {
    font-size: 0.8rem;
    margin-top: 6px;
  }

  /* 收藏夹移动端优化 */
  .favorites-modal .modal-content {
    width: 95%;
    max-height: 85vh;
    margin: 7.5vh auto;
  }

  .favorite-item {
    padding: 10px;
    gap: 10px;
  }

  .favorite-image {
    width: 50px;
    height: 50px;
  }

  .favorite-info h4 {
    font-size: 0.95rem;
  }

  .favorite-description {
    font-size: 0.8rem;
  }

  .favorite-details {
    gap: 8px;
  }

  .favorite-price {
    font-size: 0.9rem;
  }

  .favorite-duration {
    font-size: 0.8rem;
  }

  .unfavorite-btn {
    font-size: 1rem;
    padding: 6px;
  }

  /* 预约模态框移动端优化 */
  .appointments-modal .modal-content {
    width: 95%;
    max-height: 85vh;
    margin: 7.5vh auto;
  }

  .appointment-item {
    padding: 12px;
  }

  .appointment-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .appointment-header h4 {
    font-size: 1rem;
  }

  .appointment-status {
    font-size: 0.7rem;
    padding: 3px 6px;
  }

  .appointment-details p {
    font-size: 0.85rem;
    margin: 4px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MyPage.css"],"names":[],"mappings":"AAAA,WAAW;AACX,WAAW,gBAAgB,EAAE,0BAA0B,EAAE;AACzD,eAAe,iBAAiB,EAAE,mBAAmB,EAAE;AACvD,eAAe,iBAAiB,EAAE,eAAe,EAAE,uBAAuB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAClH,cAAc,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE9E,YAAY;AACZ,cAAc,eAAe,EAAE;AAC/B,0BAA0B,YAAY,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAChF,gCAAgC,wBAAwB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACnH;EACE,kBAAkB;EAClB,eAAe,EAAE,YAAY;EAC7B,4CAA4C;EAC5C,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB,EAAE,WAAW;EAC7B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,YAAY,YAAY,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AAC1D,cAAc,QAAM,EAAE;AACtB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,iCAAiC,+BAA+B,EAAE,UAAU,EAAE,2BAA2B,EAAE,8CAA8C,EAAE;AAC3J,qBAAqB,UAAU,EAAE,kBAAkB,EAAE;AACrD,cAAc,UAAU,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEpH,UAAU;AACV,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACjH,0BAA0B,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,qFAAqF,EAAE,mBAAmB,EAAE;AAC9K,eAAe,cAAc,EAAE,iBAAiB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kDAAkD,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,4EAA4E,EAAE;AACtT,mBAAmB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACpH,kBAAkB,YAAY,EAAE,2BAA2B,EAAE,eAAe,EAAE;AAC9E,YAAY,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAErF,OAAO;AACP,gBAAgB,kBAAkB,EAAE;AACpC,mBAAmB,uBAAuB,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACnH,aAAa,kBAAkB,EAAE,eAAe,EAAE;AAClD,aAAa,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,2CAA2C,EAAE,cAAc,EAAE,iBAAiB,EAAE,iCAAiC,EAAE;AACpN,wBAAwB,kBAAkB,EAAE;AAC5C,oBAAoB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,0EAA0E,EAAE,SAAS,EAAE,iCAAiC,EAAE;AACtL,mBAAmB,0BAA0B,EAAE,0CAA0C,EAAE;AAC3F,0BAA0B,SAAS,EAAE;AACrC,SAAS,wBAAwB,EAAE,cAAc,EAAE;;AAEnD,SAAS;AACT,kBAAkB,kBAAkB,EAAE;AACtC,qBAAqB,uBAAuB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAChG,eAAe,kBAAkB,EAAE,oBAAoB,EAAE;AACzD,cAAc,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,2CAA2C,EAAE;AACpJ,yBAAyB,kBAAkB,EAAE;AAC7C,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAClH,gBAAgB,YAAY,EAAE,eAAe,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AACjG,eAAe,mCAAmC,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC1F,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,wBAAwB,EAAE,yCAAyC,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACpO,kBAAkB,kCAAkC,EAAE,aAAa,EAAE;;AAErE,aAAa;AACb;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,eAAe,gBAAgB,EAAE;;EAEjC;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,SAAS;EACT;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,YAAY;EACZ;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,aAAa;AACb;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sFAAsF;EACtF,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;+DAE+D;;AAE/D,WAAW;AACX;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,WAAW;;AAEX,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;;;AAIA,aAAa;AACb;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,eAAe;EACf;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,cAAc;EACd;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,cAAc;EACd;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,aAAa;EACb;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA,eAAe;EACf;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF","sourcesContent":["/* 我的页面优化 */\n.my-page { min-height:100vh; background:var(--color-bg); }\n.login-intro { text-align:center; padding:6px 4px 4px; }\n.intro-title { font-size:1.35rem; font-weight:700; color:var(--color-text); margin:0 0 10px; letter-spacing:.5px; }\n.intro-text { color:var(--color-text-sec); margin:0 0 22px; font-size:.85rem; }\n\n/* 登录按钮与表单 */\n.login-form { padding: 20px 0; }\n.login-form .form-group { display:flex; flex-direction:column; margin:0 0 18px; }\n.login-form .form-group label { color: var(--color-text); font-weight: 600; margin-bottom: 8px; font-size: 0.9rem; }\n.login-form input {\n  padding: 16px 18px;\n  font-size: 16px; /* 防止iOS缩放 */\n  border: 1px solid var(--color-border-strong);\n  background: var(--color-surface);\n  border-radius: 16px;\n  transition: var(--transition-fast);\n  min-height: 52px; /* 确保触摸目标 */\n  width: 100%;\n}\n\n.login-form input:focus {\n  border-color: var(--color-primary);\n  box-shadow: var(--focus-ring);\n  outline: none;\n  background: var(--color-surface);\n}\n\n/* 输入类型特定优化 */\n.login-form input[type=\"tel\"] {\n  font-family: monospace;\n  letter-spacing: 1px;\n}\n\n.login-form input[type=\"text\"] {\n  text-transform: none;\n}\n\n.code-row { display:flex; gap:12px; align-items:flex-end; }\n.code-input { flex:1; }\n.code-btn {\n  height: 52px;\n  min-height: 52px;\n  min-width: 80px;\n  padding: 0 20px;\n  border: 1px solid var(--color-primary);\n  border-radius: 16px;\n  background: var(--color-surface);\n  color: var(--color-primary);\n  cursor: pointer;\n  font-weight: 600;\n  letter-spacing: .4px;\n  transition: var(--transition-fast);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.code-btn:hover:not(:disabled) { background:var(--color-primary); color:#fff; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3); }\n.code-btn:disabled { opacity:.6; cursor:not-allowed; }\n.btn.submit { width:100%; margin-top:8px; padding:16px 18px; border-radius:18px; font-size: 1rem; font-weight: 600; }\n\n/* 用户信息卡 */\n.user-info-card { border-radius:28px; margin:20px 0 24px; padding:30px 26px; position:relative; overflow:hidden; }\n.user-info-card::before { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 95% 15%,rgba(99,102,241,.2),rgba(255,255,255,0)); pointer-events:none; }\n.user-avatar { font-size:52px; margin-right:22px; width:68px; height:68px; display:flex; align-items:center; justify-content:center; background:linear-gradient(145deg,#f2f4f8,#ffffff); color:var(--color-primary); border-radius:50%; box-shadow:inset 0 1px 0 rgba(255,255,255,.6),0 4px 10px -4px rgba(0,0,0,.2); }\n.user-details h2 { margin:0 0 6px; font-size:1.2rem; font-weight:700; letter-spacing:.3px; color:var(--color-text); }\n.user-details p { margin:4px 0; color:var(--color-text-sec); font-size:.8rem; }\n.edit-btn { padding:10px 18px; border-radius:14px; font-size:.8rem; font-weight:600; }\n\n/* 菜单 */\n.menu-section { margin:24px 0 10px; }\n.menu-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; letter-spacing:.4px; font-weight:700; }\n.menu-list { border-radius:26px; overflow:hidden; }\n.menu-item { display:flex; justify-content:space-between; align-items:center; padding:18px 22px; border-bottom:1px solid var(--color-border); cursor:pointer; position:relative; transition:var(--transition-base); }\n.menu-item:last-child { border-bottom:none; }\n.menu-item::after { content:\"\"; position:absolute; inset:0; background:linear-gradient(120deg,rgba(99,102,241,.08),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); }\n.menu-item:hover { transform:translateY(-2px); box-shadow:0 4px 14px -6px rgba(0,0,0,.18); }\n.menu-item:hover::after { opacity:1; }\n.arrow { color:var(--color-muted); font-size:1rem; }\n\n/* 订单列表 */\n.orders-section { margin:30px 0 10px; }\n.orders-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; font-weight:700; }\n.orders-list { border-radius:26px; padding:10px 4px 4px; }\n.order-item { display:flex; justify-content:space-between; align-items:center; padding:16px 18px 14px; border-bottom:1px solid var(--color-border); }\n.order-item:last-child { border-bottom:none; }\n.order-info h4 { margin:0 0 6px; font-size:.95rem; font-weight:600; letter-spacing:.4px; color:var(--color-text); }\n.order-info p { margin:2px 0; font-size:.7rem; color:var(--color-text-sec); letter-spacing:.3px; }\n.order-price { color:var(--color-danger)!important; font-weight:700; letter-spacing:.4px; }\n.order-status { padding:6px 12px; border-radius:20px; font-size:.6rem; letter-spacing:1px; font-weight:700; text-transform:uppercase; box-shadow:0 2px 4px -2px rgba(0,0,0,.12); min-height:24px; display:flex; align-items:center; }\n.status-pending { background:var(--color-warning-bg); color:#856404; }\n\n/* 移动端响应式优化 */\n@media (max-width: 640px) {\n  .user-info-card {\n    flex-direction: column;\n    text-align: center;\n    padding: 24px 20px;\n  }\n\n  .user-avatar { margin: 0 0 20px; }\n\n  .edit-btn {\n    margin-top: 12px;\n    min-height: 44px;\n    padding: 12px 20px;\n  }\n\n  .menu-item {\n    padding: 18px 20px;\n    min-height: 56px;\n  }\n\n  .order-item {\n    padding: 16px 18px 14px;\n  }\n\n  /* 表单优化 */\n  .login-form input {\n    min-height: 52px;\n    padding: 16px 18px;\n    font-size: 16px;\n  }\n\n  .code-btn {\n    height: 52px;\n    min-width: 90px;\n    font-size: 0.85rem;\n  }\n\n  .btn.submit {\n    min-height: 52px;\n    padding: 16px 20px;\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .user-info-card {\n    padding: 20px 16px;\n    margin: 16px 0 20px;\n  }\n\n  .menu-item {\n    padding: 16px 18px;\n    min-height: 52px;\n  }\n\n  .order-item {\n    padding: 14px 16px 12px;\n  }\n\n  /* 表单移动端优化 */\n  .login-form {\n    padding: 16px 0;\n  }\n\n  .login-form .form-group {\n    margin-bottom: 16px;\n  }\n\n  .login-form input {\n    min-height: 48px;\n    padding: 14px 16px;\n    border-radius: 14px;\n  }\n\n  .code-row {\n    gap: 10px;\n  }\n\n  .code-btn {\n    height: 48px;\n    min-width: 80px;\n    font-size: 0.8rem;\n    padding: 0 16px;\n  }\n\n  .btn.submit {\n    min-height: 48px;\n    padding: 14px 18px;\n    font-size: 1rem;\n    border-radius: 16px;\n  }\n}\n\n@media (max-width: 360px) {\n  .login-form input {\n    min-height: 44px;\n    padding: 12px 14px;\n  }\n\n  .code-btn {\n    height: 44px;\n    min-width: 70px;\n    font-size: 0.75rem;\n    padding: 0 12px;\n  }\n\n  .btn.submit {\n    min-height: 44px;\n    padding: 12px 16px;\n  }\n}\n\n/* 触摸设备表单优化 */\n@media (pointer: coarse) {\n  .login-form input {\n    min-height: 56px;\n    padding: 18px 20px;\n  }\n\n  .code-btn {\n    height: 56px;\n    min-width: 100px;\n    padding: 0 24px;\n  }\n\n  .btn.submit {\n    min-height: 56px;\n    padding: 18px 24px;\n  }\n\n  .menu-item {\n    min-height: 60px;\n    padding: 20px 22px;\n  }\n}\n\n/* 验证码弹窗样式 */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.modal-content {\n  background: var(--color-surface);\n  border-radius: 20px;\n  width: 90%;\n  max-width: 400px;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease-out;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: var(--color-text-sec);\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: var(--transition-fast);\n}\n\n.modal-close:hover {\n  background: var(--color-surface-alt);\n  color: var(--color-text);\n}\n\n.modal-body {\n  padding: 24px;\n  text-align: center;\n}\n\n.code-tip {\n  margin: 0 0 16px;\n  color: var(--color-text-sec);\n  font-size: 0.9rem;\n}\n\n.code-display {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--color-primary);\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(99, 102, 241, 0.05));\n  border: 2px solid rgba(99, 102, 241, 0.2);\n  border-radius: 16px;\n  padding: 20px;\n  margin: 16px 0;\n  letter-spacing: 4px;\n  font-family: 'Courier New', monospace;\n}\n\n.code-note {\n  margin: 16px 0 0;\n  color: var(--color-text-sec);\n  font-size: 0.8rem;\n}\n\n.modal-footer {\n  padding: 16px 24px 24px;\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 12px;\n  background: var(--color-primary);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.btn-primary:hover {\n  background: var(--color-primary-accent);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ==========================================================\n   用户协议样式\n   ========================================================== */\n\n/* 用户协议链接 */\n.user-agreement-link {\n  text-align: center;\n  padding: 24px 20px 32px;\n  margin-top: 20px;\n}\n\n.agreement-link-btn {\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-family: inherit;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: var(--transition-fast);\n  min-height: 44px;\n  min-width: 80px;\n}\n\n.agreement-link-btn:hover {\n  color: var(--color-primary-accent);\n  text-decoration: none;\n  background: var(--color-primary-light);\n}\n\n/* 用户协议模态框 */\n.user-agreement-modal {\n  max-width: 900px;\n  max-height: 90vh;\n}\n\n.user-agreement-content {\n  line-height: 1.6;\n  color: var(--color-text);\n  font-size: 0.9rem;\n  text-align: left;\n}\n\n.agreement-section-title {\n  font-weight: 600;\n  color: var(--color-primary);\n  margin: 20px 0 12px;\n  font-size: 1rem;\n  border-left: 4px solid var(--color-primary);\n  padding-left: 12px;\n}\n\n.agreement-section-title:first-child {\n  margin-top: 0;\n}\n\n.agreement-subsection-title {\n  font-weight: 500;\n  color: var(--color-text);\n  margin: 12px 0 8px;\n  font-size: 0.9rem;\n  padding-left: 16px;\n}\n\n.agreement-section-content {\n  margin-bottom: 16px;\n  word-wrap: break-word;\n  line-height: 1.7;\n}\n\n/* 移动端用户协议样式优化 */\n@media (max-width: 480px) {\n  .user-agreement-link {\n    padding: 20px 16px 28px;\n    margin-top: 16px;\n  }\n\n  .agreement-link-btn {\n    font-size: 0.85rem;\n    padding: 6px 10px;\n    min-height: 40px;\n    min-width: 70px;\n  }\n\n  .user-agreement-modal {\n    max-height: 85vh;\n    border-radius: 16px;\n  }\n\n  .user-agreement-content {\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n\n  .agreement-section-title {\n    font-size: 0.95rem;\n    margin: 16px 0 10px;\n    padding-left: 10px;\n    border-left-width: 3px;\n  }\n\n  .agreement-subsection-title {\n    font-size: 0.85rem;\n    margin: 10px 0 6px;\n    padding-left: 14px;\n  }\n\n  .agreement-section-content {\n    margin-bottom: 14px;\n    line-height: 1.6;\n  }\n}\n\n@media (max-width: 360px) {\n  .user-agreement-link {\n    padding: 18px 14px 24px;\n  }\n\n  .agreement-link-btn {\n    font-size: 0.8rem;\n    padding: 5px 8px;\n    min-height: 36px;\n    min-width: 60px;\n  }\n\n  .user-agreement-content {\n    font-size: 0.8rem;\n  }\n\n  .agreement-section-title {\n    font-size: 0.9rem;\n    margin: 14px 0 8px;\n    padding-left: 8px;\n  }\n\n  .agreement-subsection-title {\n    font-size: 0.8rem;\n    margin: 8px 0 4px;\n    padding-left: 12px;\n  }\n\n  .agreement-section-content {\n    margin-bottom: 12px;\n  }\n}\n\n/* 新增功能样式 */\n\n/* 关于我们模态框 */\n.about-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.about-content h4 {\n  color: var(--color-primary);\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n.about-content p {\n  margin: 12px 0;\n  color: var(--color-text);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* 消息通知模态框 */\n.notification-modal .modal-content {\n  max-width: 500px;\n  max-height: 70vh;\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-item {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: var(--transition-base);\n}\n\n.notification-item:hover {\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-1px);\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.notification-header h4 {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.status-badge.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.status-completed {\n  background: #d1edff;\n  color: #0c5460;\n}\n\n.status-badge.status-review {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.notification-message {\n  color: var(--color-text-sec);\n  margin: 8px 0;\n  line-height: 1.5;\n}\n\n.notification-time {\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n  margin: 0;\n}\n\n/* 收藏夹模态框 */\n.favorites-modal .modal-content {\n  max-width: 600px;\n  max-height: 70vh;\n}\n\n.favorites-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.empty-favorites {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--color-text-sec);\n}\n\n.empty-favorites p {\n  margin: 8px 0;\n}\n\n.empty-tip {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.favorite-item {\n  display: flex;\n  align-items: center;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 12px;\n  margin-bottom: 12px;\n  gap: 12px;\n  transition: var(--transition-base);\n}\n\n.favorite-item:hover {\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-1px);\n}\n\n.favorite-image {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.favorite-info {\n  flex: 1;\n}\n\n.favorite-info h4 {\n  margin: 0 0 4px 0;\n  color: var(--color-text);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.favorite-description {\n  color: var(--color-text-sec);\n  font-size: 0.85rem;\n  margin: 4px 0 8px 0;\n  line-height: 1.4;\n}\n\n.favorite-details {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.favorite-price {\n  color: var(--color-primary);\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.favorite-duration {\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n}\n\n.favorite-actions {\n  flex-shrink: 0;\n}\n\n.unfavorite-btn {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: var(--transition-base);\n}\n\n.unfavorite-btn:hover {\n  background: var(--color-surface-alt);\n  transform: scale(1.1);\n}\n\n\n\n/* 测试账号提示样式 */\n.test-account-tip {\n  background: #f0f9ff;\n  border: 1px solid #0ea5e9;\n  border-radius: 8px;\n  padding: 12px;\n  margin: 16px 0;\n  font-size: 0.85rem;\n  color: #0369a1;\n}\n\n.test-account-tip p {\n  margin: 2px 0;\n}\n\n/* 订单操作按钮样式 */\n.order-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: var(--transition-base);\n  min-width: 70px;\n}\n\n.confirm-btn {\n  background: #10b981;\n  color: white;\n}\n\n.confirm-btn:hover {\n  background: #059669;\n}\n\n.review-btn {\n  background: var(--color-primary);\n  color: white;\n}\n\n.review-btn:hover {\n  background: #4f46e5;\n}\n\n/* 订单状态样式 */\n.status-served {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-review {\n  background: #fce7f3;\n  color: #be185d;\n}\n\n/* 空状态样式 */\n.empty-orders, .empty-reviews, .empty-appointments {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--color-text-sec);\n}\n\n.empty-orders p, .empty-reviews p, .empty-appointments p {\n  margin: 8px 0;\n}\n\n/* 评价列表模态框 */\n.reviews-modal .modal-content {\n  max-width: 600px;\n  max-height: 70vh;\n}\n\n.reviews-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.review-item {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.review-header h4 {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 1.1rem;\n}\n\n.review-time {\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n}\n\n.review-ratings {\n  margin-bottom: 12px;\n}\n\n.rating-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.rating-label {\n  min-width: 80px;\n  color: var(--color-text-sec);\n  font-size: 0.9rem;\n}\n\n.stars {\n  display: flex;\n  gap: 2px;\n}\n\n.star {\n  color: #e5e7eb;\n  font-size: 1rem;\n}\n\n.star.filled {\n  color: #fbbf24;\n}\n\n.review-comment {\n  background: var(--color-surface-alt);\n  padding: 12px;\n  border-radius: 8px;\n  border-left: 3px solid var(--color-primary);\n}\n\n.review-comment p {\n  margin: 0;\n  color: var(--color-text);\n  line-height: 1.5;\n}\n\n/* 预约列表模态框 */\n.appointments-modal .modal-content {\n  max-width: 600px;\n  max-height: 70vh;\n}\n\n.appointments-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.appointment-item {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.appointment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.appointment-header h4 {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 1.1rem;\n}\n\n.appointment-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.appointment-status.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.appointment-status.status-progress {\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n.appointment-details p {\n  margin: 6px 0;\n  color: var(--color-text-sec);\n  font-size: 0.9rem;\n}\n\n/* 评价表单模态框 */\n.review-form-modal .modal-content {\n  max-width: 500px;\n}\n\n.service-info {\n  background: var(--color-surface-alt);\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.service-info h4 {\n  margin: 0 0 8px 0;\n  color: var(--color-text);\n}\n\n.service-info p {\n  margin: 0;\n  color: var(--color-text-sec);\n  font-size: 0.9rem;\n}\n\n.rating-section {\n  margin-bottom: 20px;\n}\n\n.rating-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.rating-row .rating-label {\n  min-width: 80px;\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n.star-selector {\n  display: flex;\n  gap: 4px;\n}\n\n.star-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #e5e7eb;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  padding: 2px;\n}\n\n.star-btn:hover {\n  color: #fbbf24;\n  transform: scale(1.1);\n}\n\n.star-btn.active {\n  color: #fbbf24;\n}\n\n.comment-section {\n  margin-bottom: 20px;\n}\n\n.comment-section label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--color-text);\n  font-weight: 500;\n}\n\n.comment-section textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.comment-section textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: var(--focus-ring);\n}\n\n.btn-secondary {\n  background: var(--color-surface-alt);\n  color: var(--color-text);\n  border: 1px solid var(--color-border);\n}\n\n.btn-secondary:hover {\n  background: var(--color-border);\n}\n\n/* 收藏夹点击效果 */\n.favorite-item.clickable {\n  cursor: pointer;\n  transition: var(--transition-base);\n}\n\n.favorite-item.clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* 评价项优化样式 */\n.rating-score {\n  margin-left: 8px;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  font-weight: 500;\n}\n\n.expand-btn {\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  cursor: pointer;\n  font-size: 0.85rem;\n  margin-top: 8px;\n  padding: 4px 0;\n  transition: var(--transition-fast);\n}\n\n.expand-btn:hover {\n  color: #4f46e5;\n  text-decoration: underline;\n}\n\n/* 移动端响应式设计 */\n@media (max-width: 768px) {\n  /* 评价模态框移动端优化 */\n  .reviews-modal .modal-content {\n    width: 95%;\n    max-height: 85vh;\n    margin: 7.5vh auto;\n  }\n\n  .review-item {\n    padding: 12px;\n    margin-bottom: 12px;\n  }\n\n  .review-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .review-header h4 {\n    font-size: 1rem;\n  }\n\n  .review-time {\n    font-size: 0.8rem;\n  }\n\n  /* 星级显示移动端优化 */\n  .rating-item {\n    margin-bottom: 6px;\n  }\n\n  .rating-label {\n    min-width: 70px;\n    font-size: 0.85rem;\n  }\n\n  .stars {\n    gap: 1px;\n  }\n\n  .star {\n    font-size: 0.9rem;\n  }\n\n  .rating-score {\n    font-size: 0.75rem;\n    margin-left: 4px;\n  }\n\n  /* 评价内容移动端优化 */\n  .review-comment {\n    padding: 10px;\n    font-size: 0.9rem;\n    line-height: 1.6;\n  }\n\n  .expand-btn {\n    font-size: 0.8rem;\n    margin-top: 6px;\n  }\n\n  /* 收藏夹移动端优化 */\n  .favorites-modal .modal-content {\n    width: 95%;\n    max-height: 85vh;\n    margin: 7.5vh auto;\n  }\n\n  .favorite-item {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  .favorite-image {\n    width: 50px;\n    height: 50px;\n  }\n\n  .favorite-info h4 {\n    font-size: 0.95rem;\n  }\n\n  .favorite-description {\n    font-size: 0.8rem;\n  }\n\n  .favorite-details {\n    gap: 8px;\n  }\n\n  .favorite-price {\n    font-size: 0.9rem;\n  }\n\n  .favorite-duration {\n    font-size: 0.8rem;\n  }\n\n  .unfavorite-btn {\n    font-size: 1rem;\n    padding: 6px;\n  }\n\n  /* 预约模态框移动端优化 */\n  .appointments-modal .modal-content {\n    width: 95%;\n    max-height: 85vh;\n    margin: 7.5vh auto;\n  }\n\n  .appointment-item {\n    padding: 12px;\n  }\n\n  .appointment-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .appointment-header h4 {\n    font-size: 1rem;\n  }\n\n  .appointment-status {\n    font-size: 0.7rem;\n    padding: 3px 6px;\n  }\n\n  .appointment-details p {\n    font-size: 0.85rem;\n    margin: 4px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
